const SCOPE = 'changeLog';
export default SCOPE;

export const INIT = `${SCOPE}/INIT`;
export const FETCH_DETAIL = `${SCOPE}/FETCH_DETAIL`;
export const SET_DETAIL = `${SCOPE}/SET_DETAIL`;
export const SET_LOGS = `${SCOPE}/SET_LOGS`;
export const TOGGLE_LOADING = `${SCOPE}/TOGGLE_LOADING`;
export const TOGGLE_DETAIL = `${SCOPE}/TOGGLE_DETAIL`;
